export default function FeatureComparison() {
  return (
    <section className="py-16 md:py-24 px-6 md:px-10 bg-background-50">
      <div className="max-w-[1280px] mx-auto">
        <div className="mb-12 text-center">
          <span className="text-xs font-medium text-primary-600 uppercase tracking-widest">
            Feature Comparison
          </span>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 mt-3">
            How ACBuySpreadsheet Compares
          </h2>
          <p className="mt-3 text-sm text-foreground-600 max-w-lg mx-auto">
            See why structured spreadsheet systems outperform manual methods and generic tools for ecommerce product sourcing.
          </p>
        </div>

        <div className="overflow-x-auto">
          <table className="w-full text-sm border-collapse">
            <thead>
              <tr className="border-b border-background-200">
                <th className="text-left py-4 px-4 font-semibold text-foreground-900 whitespace-nowrap">Feature</th>
                <th className="text-center py-4 px-4 font-semibold text-primary-600 whitespace-nowrap bg-primary-50/50 rounded-t-lg">
                  <span className="font-heading">ACBuySpreadsheet</span>
                </th>
                <th className="text-center py-4 px-4 font-semibold text-foreground-700 whitespace-nowrap">Manual Research</th>
                <th className="text-center py-4 px-4 font-semibold text-foreground-700 whitespace-nowrap">Other Tools</th>
              </tr>
            </thead>
            <tbody>
              {[
                { feature: "Sourcing Speed", acbuy: "Fast", manual: "Slow", other: "Medium" },
                { feature: "Workflow Automation", acbuy: "Full", manual: "None", other: "Partial" },
                { feature: "Data Organization", acbuy: "Structured", manual: "Scattered", other: "Limited" },
                { feature: "Scalability", acbuy: "High", manual: "Low", other: "Medium" },
                { feature: "Supplier Tracking", acbuy: "Built-in", manual: "Ad-hoc", other: "Basic" },
                { feature: "Decision Support", acbuy: "Data-driven", manual: "Guesswork", other: "Minimal" },
              ].map((row, i) => (
                <tr key={i} className="border-b border-background-200/70 hover:bg-background-100/50 transition-colors">
                  <td className="py-3.5 px-4 font-medium text-foreground-800 whitespace-nowrap">{row.feature}</td>
                  <td className="py-3.5 px-4 text-center text-accent-700 font-semibold bg-primary-50/20 whitespace-nowrap">{row.acbuy}</td>
                  <td className="py-3.5 px-4 text-center text-foreground-500 whitespace-nowrap">{row.manual}</td>
                  <td className="py-3.5 px-4 text-center text-foreground-500 whitespace-nowrap">{row.other}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}